var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "278px",
    height: "207px",
    viewBox: "0 0 278 207",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Journey-screens-+-Sales-Assist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B_10.1.4",
    transform: "translate(-971.000000, -273.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(971.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.308992,206.229168 L62.404272,206.229168 C54.852192,206.229168 48.673152,200.050128 48.673152,192.498048 L48.673152,77.128128 C48.673152,69.576048 54.852192,63.397008 62.404272,63.397008 L203.308992,63.397008 C210.861072,63.397008 217.040112,69.576048 217.040112,77.128128 L217.040112,192.498048 C217.040112,200.050128 210.861072,206.229168 203.308992,206.229168 Z",
    id: "Stroke-1",
    stroke: "#373737",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.85656,
    y1: 33.47244,
    x2: 132.85656,
    y2: 63.19044,
    id: "Stroke-3",
    stroke: "#373737",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.823888,103.448088 C116.823888,103.448088 109.923408,117.248328 84.758688,116.436888",
    id: "Stroke-5",
    stroke: "#373737",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.889232,103.448088 C148.889232,103.448088 155.789712,117.248328 180.954432,116.436888",
    id: "Stroke-7",
    stroke: "#373737",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.093888,166.429512 C171.093888,166.429512 156.724128,154.864152 132.512688,154.864152 C107.533008,154.864152 94.619088,166.429512 94.619088,166.429512",
    id: "Stroke-9",
    stroke: "#373737",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(132.856488, 160.646832) scale(1, -1) translate(-132.856488, -160.646832) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.108992,
    y1: 58.302576,
    x2: 276.414912,
    y2: 58.327056,
    id: "Stroke-11",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.860088,
    y1: 49.662576,
    x2: 267.664248,
    y2: 66.967776,
    id: "Stroke-13",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.251424,
    y1: 30.332232,
    x2: 21.405024,
    y2: 30.569832,
    id: "Stroke-15",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.396768,
    y1: 24.373656,
    x2: 15.259248,
    y2: 36.528696,
    id: "Stroke-17",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.524712,
    y1: 82.445112,
    x2: 249.634872,
    y2: 74.471832,
    id: "Stroke-19",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.153856,
    y1: 55.452456,
    x2: 35.480736,
    y2: 63.172296,
    id: "Stroke-21",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.744336,56.997936 C9.744336,59.519376 7.699536,61.563456 5.178096,61.563456 C2.656656,61.563456 0.611856,59.519376 0.611856,56.997936 C0.611856,54.476496 2.656656,52.431696 5.178096,52.431696 C7.699536,52.431696 9.744336,54.476496 9.744336,56.997936 Z",
    id: "Stroke-23",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-25",
    stroke: "#16AC20",
    strokeWidth: 1.22472,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "232.96752 31.681944 224.2368 32.725944 227.52144 41.077224 221.1732 43.866504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.555328,11.185488 C143.555328,17.094528 138.765168,21.883968 132.856848,21.883968 C126.948528,21.883968 122.157648,17.094528 122.157648,11.185488 C122.157648,5.276448 126.948528,0.487008 132.856848,0.487008 C138.765168,0.487008 143.555328,5.276448 143.555328,11.185488",
    id: "Fill-27",
    fill: "#16AC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.313272,11.310624 C144.313272,17.219664 139.523832,22.009104 133.615512,22.009104 C127.706472,22.009104 122.916312,17.219664 122.916312,11.310624 C122.916312,5.402304 127.706472,0.612144 133.615512,0.612144 C139.523832,0.612144 144.313272,5.402304 144.313272,11.310624 Z",
    id: "Stroke-29",
    stroke: "#16AC20",
    strokeWidth: 1.22472
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.41be17539a7945d58ec293eefe5c0be5.svg";
export { ForwardRef as ReactComponent };